import React, { useState, useEffect, useContext } from 'react';
import { Collapse, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { RemoveCookie, GetCoockie, days, user_session_id, shopping_cart_session_id, DefaultImage, KImageURL, ValidateQty, UpdateShoppingCart, CheckSession, GetSKUDetailGlb, GetShoppingCart, generateSixDigitNumber } from "./GlobalScript";
import { ShoppingCartContext, ShoppingCartProvider } from './dealer/ShoppingCartContext';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Link, useNavigate } from 'react-router-dom';
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import CloseButton from 'react-bootstrap/CloseButton';
import Cookies from 'js-cookie';
import './NavMenu.css';
import useLocalStorage from "use-local-storage";
import { useLocation } from 'react-router-dom';
import OrderSessionPopup from './dealer/OrderSessionPopup.js';
import ItemInquiry from './dealer/ItemInquiry';
import { useTranslation } from 'react-i18next';
import { isTranslatedDomain, changeAppLanguage } from '../i18n/utils';

const NavMenu = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);
    const [showItemModal, setShowItemModal] = useState(false);
    const [quantity, setQuantity] = useState('');
    const [itemNum, setItemNum] = useState('');
    const [ItemsToitemInquiry, setItemsToitemInquiry] = useState([]);
    const [shopMenu, setShopMenu] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [pop, setPop] = useState(false);
    const [keywords, setKeywords] = useState('');
    const [partNum, setPartNum] = useState('');
    const [partQty, setPartQty] = useState('');
    const navigate = useNavigate();
    const handleShowCartClose = () => setShowCartModal(false);
    const handleShowCartOpen = () => setShowCartModal(true);
    const { shoppingCart, setShoppingCart, orderType, setOrderType, isDropdownOpen, setDropdownOpen, categoriesOpen, setCategoriesOpen } = useContext(ShoppingCartContext);
    /*const result = await GetSKUDetailGlb(skuqty, orderType, orderName, shiptoDealerID);*/
    const [userRate, setUserRate] = useState(null);
    const [starMsg, setStarMsg] = useState(false);
    const [popUpModal, setPopUpModal] = useState(false);
    const [popUpMsg, setPopUpMsg] = useState('');

    const validationSchema = Yup.object().shape({
        message: Yup.string().required(),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };
    const { control, register, handleSubmit, formState, reset } = useForm(formOptions);
    const { errors } = formState;
    /*console.log({ errors });*/

    const logoutDealerClick = () => {
        /*Cookies.remove('user', { expires: hours });*/
        RemoveCookie(days, user_session_id);
        localStorage.removeItem('shoppingcart');
        localStorage.removeItem("orderSearch");
        localStorage.removeItem("creditSearch");
        navigate('/login');
        setUserInfo(null);
    }

    const handleShowModal = (message) => {
        setPopUpMsg(message);
        setPopUpModal(true);
    }
    const handleHideModal = () => {
        setPopUpModal(false);
        setPopUpMsg('');
    }

    const { t, i18n } = useTranslation();
    const hostname = window.location.hostname.toLowerCase();
    const translationDomain = hostname.includes('k-countries') || hostname.includes('kcountries') || hostname.includes('local');

    //useEffect(() => {
    //    console.log(shoppingCart);
    //}, [shoppingCart])

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    };

    const handlePop = () => setPop(true);
    const handleClosePop = () => setPop(false);

    const handleItemModalShow = (single) => {
        const crrMap = new Map();
        if (single === true) {
            const qty = ValidateQty(quantity);
            if (itemNum !== '' && qty !== '') {
                crrMap.set(itemNum, { sku: itemNum, qty: qty });
            }
        }
        setItemsToitemInquiry(Array.from(crrMap.values()));
        setShowItemModal(true);
    }

    const handleItemModalClose = () => setShowItemModal(false);

    const handleSelectedItems = async (items) => {
        UpdateShoppingCart(items, setShoppingCart);
        navigate('/neworder');
    };

    const UpdateShoppingCartNav = async () => {
        try {
            /*const cart = localStorage.getItem(shopping_cart_session_id);*/
            const cart = GetShoppingCart(shoppingCart);
            if (cart) {
                setShoppingCart(cart);
            }
        } catch (e) {
            console.log(e);
        }
    }

    useEffect(() => {
        if (categoriesOpen || menuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [categoriesOpen, menuOpen])

    const GoToOrderForm = async () => {
        setDropdownOpen(false);
        if (window.location.pathname !== "/neworder") {
            navigate('/neworder');
        }
    }

    useEffect(() => {
        if (loading) {
            try {
                const us = GetCoockie();
                if (!userInfo && us) {
                    setUserInfo(us);
                    getMenu();
                    setLoading(false);
                }
            } catch (e) {
                setLoading(false);
                console.log(e);
            }
        }
    }, [loading, userInfo]);

    const getMenu = async () => {
        try {
            handlePop();
            const response = await fetch('catalog/GetShopMenu/');
            if (response.status !== 200) {
                handleClosePop();
                return;
            }
            const lst = await response.json();
            setShopMenu(lst);
            handleClosePop();
            /*console.log(lst);*/
        }
        catch (e) {
            handleClosePop();
            console.log(e);
        }
    }

    const GoToCatalog = async (level1, level2, level3, level1Name, level2Name, level3Name) => {
        try {
            if (!level1) {
                return;
            }
            navigate('/catalog', { state: { level1: level1, level2: level2, level1Name: level1Name, level2Name: level2Name, level3: level3, level3name: level3Name,keywords: null } });
        }
        catch (e) {
            console.log(e);
        }
    }
    const GoToCatalogWithPartNumber = async (sku) => {
        try {
            navigate('/catalog', { state: { level1: null, level2: null, level1Name: null, level2Name: null, level3: null, level3name: null, keywords: sku } });
        }
        catch (e) {
            console.log(e);
        }
    }
    //const location = useLocation();
    const [showCartModal, setShowCartModal] = useState(false);

    const handleOrderClicked = async () => {
        if (shoppingCart && shoppingCart.items.length > 0) {
            setShowCartModal(true);
        }
        else if (window.location.pathname !== "/neworder") {
            navigate('/neworder');
        }
        else {
            window.location.reload();
        }
    }

    const SearchProduct = async () => {
        if (!keywords || keywords.trim() === '') {
            return;
        }
        navigate('/catalog', { state: { level1: null, level2: null, level1Name: null, level2Name: null, keywords: keywords } });
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'txtSearch') {
            setKeywords(value);
        } else if (name === 'partNum') {
            setPartNum(value);
        } else if (name === 'partQty') {
            if (value === '') {
                setPartQty('');
            } else if (/^[1-9]\d*$/.test(value)) {
                setPartQty(Number(value));
            }
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && keywords.trim()) {
            SearchProduct();
        }
    }

    const handleAddToCart = async () => {
        try {
            handlePop();
            CheckSession();
            const user = GetCoockie();
            const partNumFormat = partNum.trim();
            if (!partNum) {
                return;
            }
            let qty = parseInt(partQty);
            if (isNaN(qty) || qty <= 0) {
                qty = 1;
            }
            const skuqty = [];
            skuqty.push({
                sku: partNumFormat,
                qty: qty
            });
            const crrMap = new Map();
            let orderType = "1";
            let dealerID = user.dealerID;
            let kCode = '';
            /*const cart = GetShoppingCart();*/
            const cart = GetShoppingCart(shoppingCart);
            if (cart && cart.orderType) {
                orderType = cart.orderType;
            }
            if (cart && cart.dealerID) {
                dealerID = cart.dealerID;
            }
            if (cart && cart.kCode) {
                kCode = cart.kCode;
            }
            //const newCart = await GetSKUDetailGlb(skuqty, orderType, orderType, dealerID);
            const arr = [];
            ////update shopping cart:add code bellow
            //if (newCart && newCart.items) {
            //    newCart.items.forEach(element => {
            //        const itmNum = element.item.distitemNbr.replaceAll('-', '');
            //        if (!crrMap.has(itmNum) && element.item.qtyOrdered > 0) {
            //            crrMap.set(itmNum, element);
            //        }
            //    });
            //}
            const crrPartNum = partNumFormat.replaceAll('-', '');
            if (cart && cart.items) {
                cart.items.forEach(element => {
                    const itmNum = element.item.distitemNbr.replaceAll('-', '');
                    if (!crrMap.has(itmNum) && element.item.qtyOrdered > 0) {
                        if (itmNum === crrPartNum) {
                            let copy = { ...element };
                            copy.item.new = true;
                            copy.item.qtyOrdered = qty;
                            copy.item.qty = qty;
                            crrMap.set(itmNum, copy);
                            arr.push(copy);
                        } else {
                            crrMap.set(itmNum, element);
                            arr.push(element);
                        }
                        
                    }
                    
                });
            }
            //if (crrMap.size > 0 && !crrMap.has(crrPartNum)) {
            //    let obj = crrMap.entries().next().value;
            //    let clone = { ...obj[1]};
            //    clone.item.distitemNbr = partNum;
            //    clone.item.qtyOrdered = qty;
            //    clone.item.qty = qty;
            //    clone.item.new = true;
            //    arr.push(clone);
            //}
            if (crrMap.size === 0 || !crrMap.has(crrPartNum)) {
                const skuqty = {
                    label: user.dealerID,
                    value: crrPartNum,
                };
                const rqst = {
                    method: 'POST',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    body: JSON.stringify(skuqty)
                };
                const res = await fetch('kdealer/GetSKUImage/', rqst);
                if (res.status !== 200) {
                    throw new Error(res.statusText);
                }
                const img = await res.text();                
                
                const item = {
                    "item":
                    {
                        "itemStaCode": "1",
                        "distitemNbr": partNumFormat,
                        "warehouseAvailColorR": "G0000002",
                        "warehouseAvailColorD": "G0000002",
                        "warehouseAvailColorL": "G0000002",
                        "dealerPrice": 0,
                        "retailPrice": 0,
                        "whslePkgCnt": 1,
                        "prodOrdCnt": qty,
                        "boCnt": 0,
                        "qty": qty,
                        "qtyOrdered": qty,
                        "factorAlert": false,
                        "errorMsg": "",
                        "inventoryType": "",
                        "inventoryTypeIcon": "",
                        "statusIcon": "",
                        "hazMatCode": "N",
                        "oversizeCode": "N",
                        "substitutedSKU": "",
                        "ltl": false,
                        "pk": false,
                        "memo": "",
                        "new": true },
                    "addInfo": {
                        "itemStaCode": "1",
                        "itemStaIcon": "green-icon",
                        "itemNumber": partNumFormat,
                        "itemStaText": null,
                        "itemDesc": "",
                        "prodLinesText": "",
                        "yearString": "",
                        "eligibleExchangeReturn": "",
                        "dimentions": "",
                        "weightVal": "",
                        "img": img,
                        "returnable": false,
                        "exchangable": false
                    }
                }
                arr.push(item);
            }
            let oName = cart ? cart.orderName : '';
            oName = oName ? oName : "";
            if (oName.trim() === '') {
                oName = generateSixDigitNumber();
            }
            const combinedCart = {
                alerts: cart ? cart.alerts : null,
                items: arr,
                orderName: oName,
                orderType: orderType,
                shipToDealerID: dealerID,
                kCode: kCode,
                fromVIPortal: false
            }
            UpdateShoppingCart(combinedCart, setShoppingCart);
        } catch (e) {
            console.log(e);
        } finally {
            setPartNum('');
            setPartQty('');
            handleClosePop();
        }
    }

    const handleQtySubtract = (item) => {
        setShoppingCart(prev => {
            if (!prev || !prev.items) return prev;

            const updatedItems = prev.items.map(i => {
                if (i.item.distitemNbr === item.distitemNbr) {
                    const newQty = Math.max(i.item.qty - 1, 1);
                    return {
                        ...i,
                        item: {
                            ...i.item,
                            qty: newQty,
                            qtyOrdered: newQty
                        }
                    };
                }
                return i;
            });

            const updatedCart = { ...prev, items: updatedItems };

            UpdateShoppingCart(updatedCart, setShoppingCart);
            return updatedCart;
        });
    }

    const handleQtyAdd = (item) => {
        setShoppingCart(prev => {
            if (!prev || !prev.items) return prev;

            const updatedItems = prev.items.map(i => {
                if (i.item.distitemNbr === item.distitemNbr) {
                    return {
                        ...i,
                        item: {
                            ...i.item,
                            qty: i.item.qty + 1,
                            qtyOrdered: i.item.qtyOrdered + 1
                        }
                    };
                }
                return i;
            });

            const updatedCart = { ...prev, items: updatedItems };

            UpdateShoppingCart(updatedCart, setShoppingCart);
            return updatedCart;
        })
    }

    const handleDeleteItem = (item) => {
        setShoppingCart(prev => {
            if (!prev || !prev.items) return prev;

            const updatedItems = prev.items.filter(i =>
                i.item.distitemNbr !== item.distitemNbr
            );

            const updatedCart = {
                ...prev,
                items: updatedItems
            };

            UpdateShoppingCart(updatedCart, setShoppingCart);
            return updatedCart;
        });
    }

    const setStarRating = (rating) => {
        setUserRate(rating);
        setStarMsg(false);
    }

    const onSubmit = async (data) => {
        //submit to SES
        CheckSession();
        const user = GetCoockie();
        if (!userRate) {
            setStarMsg(true);
            return;
        }
        const dataPst = {
            dealerID: user.dealerID,
            message: data.message,
            rating: userRate,
            consent: data.consent,
            userKey: user.userKey
        }
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(dataPst)
        };

        const res = await fetch('kdealer/SubmitFeedback', requestOptions);
        if (res.status === 200) {
            const js = await res.json();
            handleShowModal(`Thank you for your feedback! Your ticket # is ${js.value1}.`);
            setMenuOpen(false);
            reset({ message: "" });
            setUserRate(null);
        } else {
            setMenuOpen(false);
            handleShowModal('There was an error while attempting to submit your feedback. Please try again later.');
        }   
    }
    function useScreenSize() {
        const [screenSize, setScreenSize] = useState(window.innerWidth);

        useEffect(() => {
            const handleResize = () => {
                setScreenSize(window.innerWidth);
            };

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);

        return screenSize;
    }

    const screenSize = useScreenSize();

    const accountNav =
        <div className="nav-holder">
            <svg focusable="false" className="mr-1 header-profile" width="15px" height="15px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path d="M12.5,0 C14.1927168,0 15.8110042,0.330167829 17.3549107,0.990513393 C18.8988172,1.65085896 20.2287891,2.53905692 21.3448661,3.65513393 
                    C22.4609431,4.77121094 23.349141,6.10118276 24.0094866,7.64508929 C24.6698322,9.18899581 25,10.8072832 25,12.5 C25,14.1834162
                    24.6721573,15.7970533 24.0164621,17.3409598 C23.3607668,18.8848664 22.474894,20.2148382 21.358817,21.3309152 C20.24274,22.4469922 18.9127681,
                    23.3375153 17.3688616,24.0025112 C15.8249551,24.667507 14.2020174,25 12.5,25 C10.7979826,25 9.17504492,24.6698322 7.63113839,24.0094866
                    C6.08723186,23.349141 4.75958517,22.458618 3.64815848,21.3378906 C2.53673179,20.2171633 1.65085896,18.8871915 0.990513393,17.3479353
                    C0.330167829,15.8086791 0,14.1927168 0,12.5 C0,10.8072832 0.330167829,9.18899581 0.990513393,7.64508929 C1.65085896,6.10118276 2.53905692,
                    4.77121094 3.65513393,3.65513393 C4.77121094,2.53905692 6.10118276,1.65085896 7.64508929,0.990513393 C9.18899581,0.330167829 10.8072832,0 12.5,0
                    Z M21.1356027,18.8476562 C22.5213983,16.9410247 23.2142857,14.8251604 23.2142857,12.5 C23.2142857,11.0490999 22.9306204,9.66332506 22.3632812,
                    8.34263393 C21.7959421,7.0219428 21.0333009,5.88263128 20.0753348,4.92466518 C19.1173687,3.96669908 17.9780572,3.2040579 16.6573661,2.63671875
                    C15.3366749,2.0693796 13.9509001,1.78571429 12.5,1.78571429 C11.0490999,1.78571429 9.66332506,2.0693796 8.34263393,2.63671875 C7.0219428,3.2040579
                    5.88263128,3.96669908 4.92466518,4.92466518 C3.96669908,5.88263128 3.2040579,7.0219428 2.63671875,8.34263393 C2.0693796,9.66332506 1.78571429,11.0490999
                    1.78571429,12.5 C1.78571429,14.8251604 2.4786017,16.9410247 3.86439732,18.8476562 C4.47823968,15.8063464 5.90121652,14.2857143 8.13337054,14.2857143
                    C9.3517546,15.4761964 10.8072832,16.0714286 12.5,16.0714286 C14.1927168,16.0714286 15.6482454,15.4761964 16.8666295,14.2857143 C19.0987835,14.2857143
                    20.5217603,15.8063464 21.1356027,18.8476562 Z M17.8571429,9.82142857 C17.8571429,11.3002306 17.3339896,12.5627738 16.2876674,13.609096 C15.2413452,
                    14.6554182 13.978802,15.1785714 12.5,15.1785714 C11.021198,15.1785714 9.75865479,14.6554182 8.71233259,13.609096 C7.66601039,12.5627738
                    7.14285714,11.3002306 7.14285714,9.82142857 C7.14285714,8.34262653 7.66601039,7.08008336 8.71233259,6.03376116 C9.75865479,4.98743896
                    11.021198,4.46428571 12.5,4.46428571 C13.978802,4.46428571 15.2413452,4.98743896 16.2876674,6.03376116 C17.3339896,7.08008336 17.8571429,
                    8.34262653 17.8571429,9.82142857 Z" fill="#66CC33" fillRule="nonzero">
                    </path>
                </g>
            </svg>
            {screenSize > 992 ?
                <span className="heading">{userInfo && userInfo.dealerID} - {userInfo && userInfo.dealerName}</span>
                :
                <span className="bold heading">ACCOUNT</span>
            }
        </div>
        ;

    const shoppingCartIcon =
        <div className="svg-row" onClick={UpdateShoppingCartNav}>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 40.7 37.8">
                <defs>
                    <clipPath id="clippath">
                        <rect className="st0" y="-2.6" width="50.3" height="39.7" />
                    </clipPath>
                </defs>
                <g className="st3">
                    <g>
                        <path className="st10" d="M8.7,8.9h30.7s0,16.5-6.5,16c-4.9.3-21.1,1.5-21.1,1.5,1.8,2.3,1.3,1.9,20,1.6,1.2.1.9,1.6-.2,1.3-3.9,0-17.3,0-17.3,0-3,0-3.4-1.4-3.9-3.3-.7-4.2-3.4-18.5-3.4-18.5-.4-1.5-2-2.4-3.5-1.9,0,0-.1,0-.2,0-1.9,2.6-4-3,0-1.6,3.7.2,3.9.8,5.6,4.8Z" />
                        <path className="st10" d="M17.4,34.5c0,1.4-1.2,2.6-2.7,2.6-1.4,0-2.6-1.2-2.6-2.7,0-1.4,1.2-2.6,2.6-2.6,1.5,0,2.6,1.2,2.6,2.7h0" />
                        <path className="st10" d="M32.2,34.3c0,1.4-1.2,2.6-2.7,2.6-1.4,0-2.6-1.2-2.6-2.7,0-1.4,1.2-2.6,2.6-2.6,1.5,0,2.6,1.2,2.6,2.7,0,0,0,0,0,0" />
                    </g>
                </g>
            </svg>
            {/* <div className="green-text">{ShoppingCartCount ? ("(" + ShoppingCartCount + ")") :"(0)"}</div>*/}
            <ShoppingCartProvider><div className="green-text">{shoppingCart && shoppingCart.items ? ("(" + shoppingCart.items.length + ")") : "(0)"}</div></ShoppingCartProvider>

        </div>
        ;

    const shopNav =
        <div className="nav-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 40.7 37.8">
                <defs>
                    <clipPath id="clippath">
                        <rect className="st0" y="-2.6" width="50.3" height="39.7" />
                    </clipPath>
                </defs>
                <g className="st4">
                    <g>
                        <path className="st4" d="M8.7,8.9h30.7s0,16.5-6.5,16c-4.9.3-21.1,1.5-21.1,1.5,1.8,2.3,1.3,1.9,20,1.6,1.2.1.9,1.6-.2,1.3-3.9,0-17.3,0-17.3,0-3,0-3.4-1.4-3.9-3.3-.7-4.2-3.4-18.5-3.4-18.5-.4-1.5-2-2.4-3.5-1.9,0,0-.1,0-.2,0-1.9,2.6-4-3,0-1.6,3.7.2,3.9.8,5.6,4.8Z" />
                        <path className="st4" d="M17.4,34.5c0,1.4-1.2,2.6-2.7,2.6-1.4,0-2.6-1.2-2.6-2.7,0-1.4,1.2-2.6,2.6-2.6,1.5,0,2.6,1.2,2.6,2.7h0" />
                        <path className="st4" d="M32.2,34.3c0,1.4-1.2,2.6-2.7,2.6-1.4,0-2.6-1.2-2.6-2.7,0-1.4,1.2-2.6,2.6-2.6,1.5,0,2.6,1.2,2.6,2.7,0,0,0,0,0,0" />
                    </g>
                </g>
            </svg>
            <span>{t('Navigation.SHOP')}</span>
        </div>
        ;

    const ordersNav =
        <div className="nav-holder">
            <svg version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="15px" y="15px" viewBox="0 0 50 50" xmlSpace="preserve">
                <g stroke="none" strokeWidth="1">
                    <polygon className="st4" points="13.19,3.53 13.19,8.96 7.48,8.96 "></polygon>
                    <path className="st4" d="M-66.52,44.61"></path>
                    <path className="st4" d="M40.45,1.75H17.29c-0.82,0-1.48,0.66-1.48,1.48v6.77c0,0.82-0.66,1.48-1.48,1.48H7.46 
                    c-0.82,0-1.48,0.66-1.48,1.48v32.49c0,0.82,0.66,1.48,1.48,1.48h32.99c0.82,0,1.48-0.66,1.48-1.48V3.24 
                    C41.94,2.42,41.27,1.75,40.45,1.75z M18.17,38.88h-8c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h8 
                    c0.64,0,1.15,0.52,1.15,1.15C19.33,38.37,18.81,38.88,18.17,38.88z M26.34,30.47c0,0.64-0.52,1.15-1.15,1.15H10.18 
                    c-0.64,0-1.15-0.52-1.15-1.15v0c0-0.64,0.52-1.15,1.15-1.15h15.01C25.82,29.32,26.34,29.83,26.34,30.47L26.34,30.47z M37.58,24.37 
                    H10.18c-0.64,0-1.15-0.52-1.15-1.15s0.52-1.15,1.15-1.15h27.41c0.64,0,1.15,0.52,1.15,1.15S38.22,24.37,37.58,24.37z M37.58,17.11 
                    H10.18c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h27.41c0.64,0,1.15,0.52,1.15,1.15 
                    C38.74,16.59,38.22,17.11,37.58,17.11z M37.58,9.85h-17.5c-0.64,0-1.15-0.52-1.15-1.15c0-0.64,0.52-1.15,1.15-1.15h17.5 
                    c0.64,0,1.15,0.52,1.15,1.15C38.74,9.33,38.22,9.85,37.58,9.85z"></path>
                </g>
            </svg>
            <span>{t('Navigation.ORDERS')}</span>
        </div>
        ;

    const creditNav =
        <div className="nav-holder">
            <svg version="1.1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="15px" y="15px" viewBox="0 0 50 50" xmlSpace="preserve">
                <g className="st4">
                    <path className="st4" d="M24.44,2.28c-12.92,0-23.39,10.47-23.39,23.39s10.47,23.39,23.39,23.39s23.39-10.47,23.39-23.39 
                    S37.35,2.28,24.44,2.28z M25.84,40.25v3.46h-1.76v-3.42c-4.77-0.24-7.09-2.94-7.26-8.85l5.29-0.79c0.03,3.63,0.86,4.98,2.42,4.98 
                    c1.28,0,1.56-1.07,1.56-2.04c0-2.32-1.18-3.7-3.04-5.32l-2.45-2.11c-2.07-1.83-3.77-3.7-3.77-7.29c0-4.39,2.7-6.95,6.95-7.26V8.31 
                    h1.76v3.25c5.36,0.31,6.01,4.84,6.12,7.92l-5.36,0.66c-0.07-2.49-0.21-4.15-1.8-4.08c-1.17,0-1.69,1.21-1.69,2.18 
                    c0,2.21,1.35,3.39,2.7,4.6l2.35,2.04c2.35,2.14,4.32,4.53,4.32,8.4C32.16,36.97,29.74,39.87,25.84,40.25z"></path>
                </g>
            </svg>
            <span>{t('Navigation.CREDIT REQUESTS')}</span>
        </div>
        ;

    const kLoyaltyNav =
        <div className="nav-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7">
                <path className="st4" d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
            </svg>
            <span>{t('Navigation.K-LOYALTY')}</span>
        </div>
        ;

    const helpNav =
        <div className="nav-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 30.7 22.7">
                <path className="st4" d="M30,21.5h0l-5.4-2.4H3.9c-1.7,0-3-1.3-3-3V5.1c0-1.7,1.3-3,3-3h21c1.7,0,3,1.3,3,3v11c0,.2,0,.4,0,.6l2.2,4.8h0ZM12.9,13.7v1.9h1.9v-1.9h-1.9ZM14.3,
                6.6c.5,0,.8.3.8,1-.1,1.4-.9,2.8-2.1,3.6v1.7h1.8v-1.3c1.4-.9,2.2-2.4,2.3-4,.1-1.3-.9-2.5-2.2-2.7-.2,0-.3,0-.5,0-1.3-.2-2.4.7-2.6,2,0,.1,0,.3,0,.4,0,.4,0,
                .8.2,1.1l1.8-.4c0-.2-.1-.5-.1-.7,0-.4.2-.7.6-.8,0,0,0,0,.1,0h0Z" />
            </svg>
            <span>{t('Navigation.HELP CENTER')}</span>
        </div>
        ;

    const advancedNav =
        <div className="nav-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 46.2 47.6">
                <g>
                    <g className="st4">
                        <g>
                            <path className="st4" d="M27.5,34.2c-5.8,2.4-12.5-.3-15-6-2.4-5.7.3-12.3,6-14.7,0,0,.1,0,.2,0,5.8-2.4,12.5.3,15,6,2.4,5.7-.3,12.3-6,14.7,0,0-.1,0-.2,
                                                    0M37.3,20.7l2.9-1.2-1.8-4.4-2.9,1.2c-1.2-1.9-2.7-3.4-4.6-4.6l1.2-2.8-4.4-1.8-1.2,2.8c-2.2-.5-4.4-.5-6.5,0l-1.2-2.8-4.4,1.8,1.2,2.8c-1.9,1.1-3.5,
                                                    2.7-4.7,4.5l-2.9-1.2-1.9,4.4,2.9,1.2c-.5,2.1-.5,4.3,0,6.4l-2.9,1.2,1.8,4.4,2.9-1.2c1.2,1.9,2.7,3.4,4.6,4.6l-1.2,2.8,4.4,1.8,1.2-2.8c2.2.5,4.4.5,
                                                    6.5,0l1.2,2.8,4.5-1.8-1.2-2.8c1.9-1.1,3.5-2.7,4.7-4.5l2.9,1.2,1.9-4.4-2.9-1.2c.5-2.1.5-4.3,0-6.4"></path>
                            <path className="st4" d="M40.5,27.4l-2.2-.9c.3-1.8.3-3.6,0-5.3l2.2-.9c.2,0,.4-.3.5-.5,0-.2,0-.5,0-.7l-1.8-4.4c-.2-.5-.7-.7-1.2-.5l-2.2.9c-1-1.5-2.3-2.8-3.8-3.8l.9-2.1c0-.2,
                                                    0-.5,0-.7,0-.2-.3-.4-.5-.5l-4.4-1.8c-.5-.2-1,0-1.2.5l-.9,2.1c-1.8-.3-3.6-.3-5.4,0l-.9-2.1c-.2-.5-.7-.7-1.2-.5l-4.5,
                                                    1.8c-.5.2-.7.7-.5,1.2,0,0,0,0,0,0l.9,2.1c-1.5,1-2.8,2.3-3.8,3.7l-2.2-.9c-.5-.2-1,0-1.2.5l-1.9,4.4c0,.2,0,.5,0,.7,0,.2.3.4.5.5l2.2.9c-.3,1.8-.3,
                                                    3.6,0,5.3l-2.2.9c-.2,0-.4.3-.5.5,0,.2,0,.5,0,.7l1.8,4.4c0,.2.3.4.5.5.2,0,.5,0,.7,0l2.2-.9c1,1.5,2.3,2.8,3.8,3.8l-.9,2.1c-.2.5,0,1,.5,1.2,0,0,0,
                                                    0,0,0l4.4,1.8c.2,0,.5,0,.7,0,.2,0,.4-.3.5-.5l.9-2.1c1.8.3,3.6.3,5.4,0l.9,2.1c0,.2.3.4.5.5.1,0,.2,0,.4,0,.1,0,.2,0,.4,0l4.5-1.8c.5-.2.7-.7.5-1.2,
                                                    0,0,0,0,0,0l-.9-2.1c1.5-1,2.8-2.3,3.8-3.7l2.2.9c.5.2,1,0,1.2-.5l1.9-4.4c0-.2,0-.5,0-.7,0-.2-.3-.4-.5-.5M37.8,31.4l-2-.8c-.4-.2-.9,0-1.2.4-1.1,
                                                    1.7-2.6,3.2-4.4,4.2-.4.2-.5.7-.4,1.1l.8,2-2.7,1.1-.8-2c-.1-.3-.5-.6-.9-.6,0,0-.1,0-.2,0-2,.5-4.1.4-6.1,0-.4-.1-.9.1-1.1.5l-.8,2-2.7-1.1.8-2c.2-.4,
                                                    0-.9-.4-1.1-1.7-1.1-3.2-2.5-4.3-4.3-.2-.4-.7-.5-1.2-.4l-2,.8-1.1-2.7,2-.8c.4-.2.7-.6.6-1.1-.5-2-.5-4,0-6,.1-.4-.1-.9-.6-1.1l-2-.8,1.1-2.7,2,.8c.4.2.9,
                                                    0,1.2-.4,1.1-1.7,2.6-3.2,4.4-4.2.4-.2.5-.7.4-1.1l-.8-2,2.7-1.1.8,2c.2.4.6.7,1.1.6,2-.5,4.1-.4,6.1,0,.4.1.9-.1,1.1-.5l.8-2,2.7,1.1-.8,2c-.2.4,0,.9.4,
                                                    1.1,1.7,1.1,3.2,2.5,4.3,4.3.2.4.7.5,1.2.4l2-.8,1.1,2.7-2,.8c-.4.2-.7.6-.6,1.1.5,2,.5,4,0,6-.1.4.1.9.6,1.1l2,.8-1.1,2.7Z"></path>
                            <path className="st0" d="M27.8,12.5c-3-1.2-6.5-1.2-9.5,0-3,1.2-5.4,3.6-6.7,6.6-1.3,3-1.2,6.4,0,9.3,1.3,3,3.7,5.4,6.7,6.6,3,1.2,6.5,1.2,9.5,0,6.2-2.5,
                                                    9.2-9.6,6.7-15.8-1.2-3.1-3.7-5.5-6.8-6.8M27.2,33.3c-2.6,1.1-5.5,1.1-8.1,0-2.6-1-4.6-3-5.7-5.6-1.1-2.5-1.1-5.4,0-7.9,1.1-2.6,3.1-4.6,5.7-5.6,
                                                    2.6-1.1,5.5-1.1,8.1,0,5.3,2.1,7.9,8.1,5.8,13.3-1,2.6-3.1,4.7-5.7,5.8"></path>
                            <path className="st4" d="M18.7,13.4h0ZM23.1,13.4c-1.4,0-2.8.3-4.1.8-2.6,1-4.6,3.1-5.7,5.6-1.1,2.5-1,5.4,0,7.9,1.1,2.6,3.2,4.6,5.7,5.6,2.6,1,5.5,
                                                    1,8.1,0,5.3-2.1,7.8-8.1,5.7-13.4-1.1-2.6-3.2-4.7-5.8-5.7-1.3-.5-2.6-.8-4-.8M23.1,36c-1.6,0-3.2-.3-4.7-.9-3-1.2-5.5-3.6-6.7-6.6-1.3-3-1.3-6.3,
                                                    0-9.3,1.3-3,3.7-5.4,6.7-6.6,3-1.3,6.4-1.3,9.5,0,6.2,2.4,9.3,9.5,6.9,15.7-1.2,3.1-3.7,5.6-6.8,6.8-1.5.6-3.2,1-4.8,1"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <span>ADVANCED</span>
        </div>
        ;

    const feedbackNav =
        <div className="nav-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 46.2 47.6">
                <g>
                    <g className="st4">
                        <g>
                            <path className="st4" d="M27.5,34.2c-5.8,2.4-12.5-.3-15-6-2.4-5.7.3-12.3,6-14.7,0,0,.1,0,.2,0,5.8-2.4,12.5.3,15,6,2.4,5.7-.3,12.3-6,14.7,0,0-.1,0-.2,
                                                    0M37.3,20.7l2.9-1.2-1.8-4.4-2.9,1.2c-1.2-1.9-2.7-3.4-4.6-4.6l1.2-2.8-4.4-1.8-1.2,2.8c-2.2-.5-4.4-.5-6.5,0l-1.2-2.8-4.4,1.8,1.2,2.8c-1.9,1.1-3.5,
                                                    2.7-4.7,4.5l-2.9-1.2-1.9,4.4,2.9,1.2c-.5,2.1-.5,4.3,0,6.4l-2.9,1.2,1.8,4.4,2.9-1.2c1.2,1.9,2.7,3.4,4.6,4.6l-1.2,2.8,4.4,1.8,1.2-2.8c2.2.5,4.4.5,
                                                    6.5,0l1.2,2.8,4.5-1.8-1.2-2.8c1.9-1.1,3.5-2.7,4.7-4.5l2.9,1.2,1.9-4.4-2.9-1.2c.5-2.1.5-4.3,0-6.4"></path>
                            <path className="st4" d="M40.5,27.4l-2.2-.9c.3-1.8.3-3.6,0-5.3l2.2-.9c.2,0,.4-.3.5-.5,0-.2,0-.5,0-.7l-1.8-4.4c-.2-.5-.7-.7-1.2-.5l-2.2.9c-1-1.5-2.3-2.8-3.8-3.8l.9-2.1c0-.2,
                                                    0-.5,0-.7,0-.2-.3-.4-.5-.5l-4.4-1.8c-.5-.2-1,0-1.2.5l-.9,2.1c-1.8-.3-3.6-.3-5.4,0l-.9-2.1c-.2-.5-.7-.7-1.2-.5l-4.5,
                                                    1.8c-.5.2-.7.7-.5,1.2,0,0,0,0,0,0l.9,2.1c-1.5,1-2.8,2.3-3.8,3.7l-2.2-.9c-.5-.2-1,0-1.2.5l-1.9,4.4c0,.2,0,.5,0,.7,0,.2.3.4.5.5l2.2.9c-.3,1.8-.3,
                                                    3.6,0,5.3l-2.2.9c-.2,0-.4.3-.5.5,0,.2,0,.5,0,.7l1.8,4.4c0,.2.3.4.5.5.2,0,.5,0,.7,0l2.2-.9c1,1.5,2.3,2.8,3.8,3.8l-.9,2.1c-.2.5,0,1,.5,1.2,0,0,0,
                                                    0,0,0l4.4,1.8c.2,0,.5,0,.7,0,.2,0,.4-.3.5-.5l.9-2.1c1.8.3,3.6.3,5.4,0l.9,2.1c0,.2.3.4.5.5.1,0,.2,0,.4,0,.1,0,.2,0,.4,0l4.5-1.8c.5-.2.7-.7.5-1.2,
                                                    0,0,0,0,0,0l-.9-2.1c1.5-1,2.8-2.3,3.8-3.7l2.2.9c.5.2,1,0,1.2-.5l1.9-4.4c0-.2,0-.5,0-.7,0-.2-.3-.4-.5-.5M37.8,31.4l-2-.8c-.4-.2-.9,0-1.2.4-1.1,
                                                    1.7-2.6,3.2-4.4,4.2-.4.2-.5.7-.4,1.1l.8,2-2.7,1.1-.8-2c-.1-.3-.5-.6-.9-.6,0,0-.1,0-.2,0-2,.5-4.1.4-6.1,0-.4-.1-.9.1-1.1.5l-.8,2-2.7-1.1.8-2c.2-.4,
                                                    0-.9-.4-1.1-1.7-1.1-3.2-2.5-4.3-4.3-.2-.4-.7-.5-1.2-.4l-2,.8-1.1-2.7,2-.8c.4-.2.7-.6.6-1.1-.5-2-.5-4,0-6,.1-.4-.1-.9-.6-1.1l-2-.8,1.1-2.7,2,.8c.4.2.9,
                                                    0,1.2-.4,1.1-1.7,2.6-3.2,4.4-4.2.4-.2.5-.7.4-1.1l-.8-2,2.7-1.1.8,2c.2.4.6.7,1.1.6,2-.5,4.1-.4,6.1,0,.4.1.9-.1,1.1-.5l.8-2,2.7,1.1-.8,2c-.2.4,0,.9.4,
                                                    1.1,1.7,1.1,3.2,2.5,4.3,4.3.2.4.7.5,1.2.4l2-.8,1.1,2.7-2,.8c-.4.2-.7.6-.6,1.1.5,2,.5,4,0,6-.1.4.1.9.6,1.1l2,.8-1.1,2.7Z"></path>
                            <path className="st0" d="M27.8,12.5c-3-1.2-6.5-1.2-9.5,0-3,1.2-5.4,3.6-6.7,6.6-1.3,3-1.2,6.4,0,9.3,1.3,3,3.7,5.4,6.7,6.6,3,1.2,6.5,1.2,9.5,0,6.2-2.5,
                                                    9.2-9.6,6.7-15.8-1.2-3.1-3.7-5.5-6.8-6.8M27.2,33.3c-2.6,1.1-5.5,1.1-8.1,0-2.6-1-4.6-3-5.7-5.6-1.1-2.5-1.1-5.4,0-7.9,1.1-2.6,3.1-4.6,5.7-5.6,
                                                    2.6-1.1,5.5-1.1,8.1,0,5.3,2.1,7.9,8.1,5.8,13.3-1,2.6-3.1,4.7-5.7,5.8"></path>
                            <path className="st4" d="M18.7,13.4h0ZM23.1,13.4c-1.4,0-2.8.3-4.1.8-2.6,1-4.6,3.1-5.7,5.6-1.1,2.5-1,5.4,0,7.9,1.1,2.6,3.2,4.6,5.7,5.6,2.6,1,5.5,
                                                    1,8.1,0,5.3-2.1,7.8-8.1,5.7-13.4-1.1-2.6-3.2-4.7-5.8-5.7-1.3-.5-2.6-.8-4-.8M23.1,36c-1.6,0-3.2-.3-4.7-.9-3-1.2-5.5-3.6-6.7-6.6-1.3-3-1.3-6.3,
                                                    0-9.3,1.3-3,3.7-5.4,6.7-6.6,3-1.3,6.4-1.3,9.5,0,6.2,2.4,9.3,9.5,6.9,15.7-1.2,3.1-3.7,5.6-6.8,6.8-1.5.6-3.2,1-4.8,1"></path>
                        </g>
                    </g>
                </g>
            </svg>
            <span>GIVE FEEDBACK</span>
        </div>
        ;

    return (
        <>
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white box-shadow" container="true" light="true" fixed={userInfo ? "top" : "" }>
                    <Container>
                        <Navbar.Brand>
                            {userInfo ?
                                <>
                                    <Link to={userInfo.loginType === 1 ? "/dealerhome" : "/kcountrieshome"}>
                                        <img
                                            alt="Kawasaki logo"
                                            src="/images/Kawasaki_Brand_Logo_Red_Black.png"
                                            width="200"
                                            height="50"
                                            className="d-inline-block align-top main-header-logo"
                                        />
                                    </Link>
                                </>
                                :
                                <>
                                    <img
                                        alt="Kawasaki logo"
                                        src="/images/Kawasaki_Brand_Logo_Red_Black.png"
                                        width="200"
                                        height="50"
                                        className="d-inline-block align-top main-header-logo"
                                    />
                                </>
                            }
                        </Navbar.Brand>
                        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>

                            {window.location.origin.indexOf("localhost") > -1 &&
                                <Nav>
                                    <NavDropdown title="Local Links" id="local-dropdown-links">
                                        <NavDropdown.Item>
                                            <NavLink tag={Link} className="text-dark" to="/helpcenter">Help Center</NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavLink tag={Link} className="text-dark" to="/login">Login</NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavLink tag={Link} className="text-dark" to="/kmcapitest">KMC API Test</NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavLink tag={Link} className="text-dark" to="/punchout-test">Punchout Test</NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavLink tag={Link} className="text-dark" to="/ssotest?id=1de9574e8d9b43cebc23">Post K Dealer Login Test</NavLink>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavLink tag={Link} className="text-dark" to="/ssotest?id=d274253537ee40d59c1a">Post K Country Login Test</NavLink>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav>
                            }

                            {translationDomain && 
                                <Nav>
                                    <NavDropdown title={t("nav.selectLanguage")} id="language-selector" aria-label="Select language">
                                        <NavDropdown.Item>
                                            <NavItem className={i18n.language === 'en' ? "text-dark bold" : "text-dark"} onClick={() => changeAppLanguage('en')}>English</NavItem>
                                        </NavDropdown.Item>
                                        <NavDropdown.Item>
                                            <NavItem className={i18n.language === 'es' ? "text-dark bold" : "text-dark"} onClick={() => changeAppLanguage('es')}>Espa&ntilde;ol</NavItem>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav>
                            }

                            {userInfo &&
                                <Nav className="nav-logged-in">
                                    <div className="nav-header-item nav-account">
                                        <NavDropdown title={accountNav} id="collapsible-nav-dropdown1" className="dropdown-no-icon">
                                            <NavDropdown.Item>
                                                <Row className="mb-2">
                                                    <Col sm={12}>
                                                        <h3 className="heading vertical-line mb-3">{t("nav.yourAccount")}</h3>
                                                        {userInfo &&
                                                            <>
                                                                <h4 className="green-text">{userInfo.dealerName}</h4>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <p>{t("nav.accountId")}</p>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <p>{userInfo.dealerID}</p>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <p>{t("nav.regionDistrict")}</p>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <p>{userInfo.region}</p>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col sm={6}>
                                                                        <p>{t("nav.address")}</p>
                                                                    </Col>
                                                                    <Col sm={6}>
                                                                        <p>{userInfo.address}</p>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        }
                                                    </Col>
                                                </Row>

                                                <Row className="black-bg">
                                                    {/*<Col className="text-center">*/}
                                                    {/*    <Button variant="secondary" onClick={() => navigate("/comingsoon")}>*/}
                                                    {/*        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">*/}
                                                    {/*            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />*/}
                                                    {/*        </svg>*/}
                                                    {/*        MY ACCOUNT*/}
                                                    {/*    </Button>*/}
                                                    {/*</Col>*/}

                                                    <Col className="text-center" onClick={logoutDealerClick}>
                                                        <Button variant="primary">
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            {t("nav.logout")}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </NavDropdown.Item>
                                        </NavDropdown>

                                        {/*<NavDropdown.Item onClick={logoutDealerClick}>*/}
                                        {/*    Logout*/}
                                        {/*</NavDropdown.Item>*/}
                                    </div>

                                    <div className="nav-header-item border-left">
                                        <div className="nav-holder clickable" onClick={() => handleItemModalShow(false)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36.7 36.3" style={{ marginRight: 7 }}>
                                                <g>
                                                    <path className="green" d="M10,1.2c-.9,0-1.6.7-1.6,1.6v24.5c0,.9.7,1.6,1.6,1.6h24.5c.9,0,1.6-.7,1.6-1.6V2.9c0-.9-.7-1.6-1.6-1.6H10ZM32.9,25.7H11.6V4.5h21.2v21.2Z" />
                                                    <path className="green" d="M15.4,16.7h5.2v5.2c0,.9.7,1.6,1.6,1.6.9,0,1.6-.7,1.6-1.6v-5.2h5.2c.9,0,1.6-.7,1.7-1.6s-.7-1.6-1.6-1.7c0,0,0,0,0,0h-5.2v-5.2c0-.9-.8-1.6-1.7-1.6-.9,0-1.6.7-1.6,1.6v5.2h-5.2c-.9,0-1.6.8-1.6,1.7,0,.9.7,1.6,1.6,1.6h0Z" />
                                                    <path className="green" d="M2.4,35.7h26.3c.9,0,1.6-.8,1.6-1.7,0-.9-.7-1.6-1.6-1.6H4.1V8.4c0-.9-.8-1.6-1.7-1.6-.9,0-1.6.7-1.6,1.6v25.7c0,.9.7,1.6,1.6,1.6Z" />
                                                </g>
                                            </svg>

                                            <span className="bold heading">{t('Navigation.ITEM INQUIRY')}</span>
                                        </div>
                                    </div>

                                    <div className="nav-header-item nav-shopping-cart border-left">
                                        <NavDropdown title={shoppingCartIcon} id="collapsible-nav-dropdown1" className="dropdown-no-icon" show={isDropdownOpen} onToggle={(isOpen) => setDropdownOpen(isOpen)}>
                                            <NavDropdown.Item onClick={(e) => e.stopPropagation()}>
                                                <Row>
                                                    <Col sm={12}>
                                                        <h3 className="heading vertical-line">{t("shoppingCart.quickAdd")}</h3>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-2">
                                                    <Col sm={12}>
                                                        <p className="mb-0">{t("shoppingCart.quickAddDescription")}</p>
                                                    </Col>
                                                    <Col sm={5}>
                                                        <FloatingLabel label={t("shoppingCart.partNumber")} >
                                                            <Form.Control id="partNum" type="text" placeholder="Part #" value={partNum} className={'form-control'} onChange={handleChange} name="partNum" maxLength={50} />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col sm={3}>
                                                        <FloatingLabel label={t("shoppingCart.qty")} >
                                                            <Form.Control id="partQty" type="number" placeholder="Qty" value={partQty} className={'form-control'} onChange={handleChange} name="partQty" maxLength={6} min={1} />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col sm={4} className="text-center">
                                                        <Button variant="primary" className="mt-2" onClick={handleAddToCart}>
                                                            {t("shoppingCart.addItem")}
                                                        </Button>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col sm={12}>
                                                        <h3 className="heading vertical-line">{t("shoppingCart.yourCart")}</h3>
                                                    </Col>
                                                </Row>
                                                <Row className="mt-3 shopping-cart-items">
                                                    {shoppingCart && shoppingCart.items ? shoppingCart.items.map((d, index) =>
                                                        <React.Fragment key={index}>
                                                            <Col sm={1} className="mt-3">{index + 1}</Col>
                                                            <Col sm={2} className="mb-3">
                                                                {/*<img src={"../../../Images/404.png"} alt="Product" className="item-image"></img>*/}
                                                                <img src={KImageURL(d.item.distitemNbr, d.addInfo?.img)}
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null;
                                                                        currentTarget.src = DefaultImage;
                                                                    }}
                                                                    alt="Product" className={"item-image"}>
                                                                </img>
                                                            </Col>
                                                            <Col sm={9}>
                                                                <p className="mb-0">{d.addInfo && d.addInfo.itemDesc}</p>
                                                                <p className="mb-0">{t("shoppingCart.itemNo")} {d.item && d.item.distitemNbr}</p>
                                                                {/*<div className="icons-row">*/}
                                                                {/*    <span className="svg-holder small-svg">*/}
                                                                {/*        <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} ></img>*/}
                                                                {/*    </span>*/}
                                                                {/*    |*/}
                                                                {/*    <span className="svg-holder small-svg">*/}
                                                                {/*        <div className={`status-icon ${d.addInfo.itemStaIcon}`}></div>*/}
                                                                {/*    </span>*/}
                                                                {/*    {d.item.statusIcon.indexOf('.svg') > -1 &&*/}
                                                                {/*        <>|<span className="svg-holder small-svg"><img className="margin-left" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img></span></>*/}
                                                                {/*    }*/}
                                                                {/*    {d.item.boCnt > 0 && <>|<span className="svg-holder small-svg"><img src="../../../Images/backorder.svg" alt="" className="margin-left" /></span></>}*/}
                                                                {/*</div>*/}
                                                                {/* {d.item && <span className="svg-holder"> <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt="Inventory_Type"></img></span> | <span className="svg-holder"><img src={"../../../Images/" + d.item.statusIcon} alt="Sku_Status"></img></span>}*/}

                                                                <Row className="g-2">
                                                                    <Col className="col-fit-width">
                                                                        <Button className="btn-small btn-plain mt-1" onClick={() => handleDeleteItem(d.item)}>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                            </svg>
                                                                        </Button>
                                                                    </Col>

                                                                    <Col className="col-fit-width">
                                                                        <p className="mt-2">{t("shoppingCart.qtyLabel")}</p>
                                                                    </Col>

                                                                    <Col className="col-fit-width">
                                                                        <div className="qty-control">
                                                                            <Button variant="danger" className="btn-small btn-plain" onClick={() => handleQtySubtract(d.item)}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-dash" viewBox="0 0 16 16">
                                                                                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8" />
                                                                                </svg>
                                                                            </Button>

                                                                            <p className="bold">{d.item && d.item.qty}</p>

                                                                            <Button className="btn-small btn-plain" onClick={() => handleQtyAdd(d.item)}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                                                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                                                                </svg>
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </React.Fragment>

                                                    ) :
                                                        <>
                                                            <Col>
                                                                <p>{t("shoppingCart.empty")}</p>
                                                            </Col>
                                                        </>
                                                    }
                                                </Row>

                                                <Row className="black-bg">
                                                    <Col className="text-center">
                                                        <Button variant="secondary" onClick={() => setDropdownOpen(false)}>
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            {t("shoppingCart.continueShopping")}
                                                        </Button>
                                                    </Col>

                                                    <Col className="text-center">
                                                        <Button variant="primary" onClick={GoToOrderForm}>
                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                            </svg>
                                                            {t("shoppingCart.checkout")}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </div>

                                    <div className="nav-header-item">
                                        <div className="input-group nav-search">
                                            <input name="txtSearch" type="text" id="txtSearch" value={keywords} onChange={handleChange} className="form-control" placeholder={t("nav.search")} aria-label="Search" onKeyDown={handleKeyDown} />
                                            {/*<a id="btnSearchHeader" className="nav-search" href="#" onClick={SearchProduct}>*/}
                                            {/*    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search nav-search-btn" viewBox="0 0 16 16">*/}
                                            {/*        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>*/}
                                            {/*    </svg>*/}
                                            {/*</a>*/}
                                            <button className="nav-search btn" onClick={SearchProduct} title="search">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search nav-search-btn" viewBox="0 0 16 16">
                                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </Nav>
                            }
                        </Collapse>
                    </Container>
                </Navbar>

                {userInfo ?
                    <Navbar className="second-nav">
                        <Container>
                            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                            <Navbar.Collapse id="responsive-navbar-nav">
                                <Nav className="me-auto">
                                    <NavDropdown title={shopNav} id="collapsible-nav-dropdown1" className="nav-extended-dropdown" show={categoriesOpen} onToggle={(isOpen) => setCategoriesOpen(isOpen)}>
                                        <NavDropdown.Item as="div">
                                            <Container>
                                                <Row>
                                                    <Col sm={4}>
                                                        <h2 className="heading vertical-line">{t('Navigation.SHOP BY CATEGORY')}</h2>
                                                    </Col>

                                                    <Col sm={8}>
                                                        <Row className="border-left">
                                                            {shopMenu && shopMenu.map((menu, index) => (
                                                                <Col lg={3} sm={4} key={index}>
                                                                    <h3 className="heading" key={menu.id} id={menu.id} onClick={() => GoToCatalog(menu.id,null, null, menu.topCategory, null,null)}>{menu.topCategory}</h3>
                                                                    <ul>
                                                                        {(menu.id === '3' || menu.id === '24') && menu.partNumberLevel.length === 0 && menu.subCategory.map(item => (
                                                                            <li key={item.value} id={item.value} onClick={() => GoToCatalog(menu.id, item.value,null, menu.topCategory, item.label,null)}>{item.label}</li>
                                                                        ))}
                                                                        {(menu.id !== '3' && menu.id !== '24') && menu.partNumberLevel.length === 0 && menu.categoryLevel.map(item => (
                                                                            <li key={item.value} id={item.value} onClick={() => GoToCatalog(menu.id,null, item.value, menu.topCategory,null, item.label)}>{item.label}</li>
                                                                        ))}
                                                                        {menu.partNumberLevel.length > 0 && menu.partNumberLevel.map(item => (
                                                                            <li key={item.value} id={item.value} onClick={() => GoToCatalogWithPartNumber(item.value)}>{item.label}</li>
                                                                        ))}
                                                                    </ul>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </NavDropdown.Item>
                                    </NavDropdown>

                                    <NavDropdown title={ordersNav} id="collapsible-nav-dropdown2">
                                        <NavDropdown.Item onClick={handleOrderClicked}>{t('Navigation.New Order')}</NavDropdown.Item>
                                        <NavDropdown.Item href="/orderhistory">{t('Navigation.Order History')}</NavDropdown.Item>
                                        <NavDropdown.Item href="/savedorders">{t('Navigation.Saved Orders')}</NavDropdown.Item>
                                        <NavDropdown.Item href="/backorders">{t('Navigation.Back Orders')}</NavDropdown.Item>
                                        {userInfo && userInfo.loginType === 5 && <NavDropdown.Item href="/allocatedorders">{t("Navigation.allocatedOrders")}</NavDropdown.Item>}
                                    </NavDropdown>

                                    {userInfo.loginType !== 5 && 
                                        <>
                                            <NavDropdown title={creditNav} id="collapsible-nav-dropdown3">
                                                <NavDropdown.Item href="/creditrequest">{t('Navigation.New Credit Request')}</NavDropdown.Item>
                                                <NavDropdown.Item href="/credithistory">{t('Navigation.Credit Request History')}</NavDropdown.Item>
                                            </NavDropdown>
                                        
                                            <NavDropdown title={kLoyaltyNav} id="collapsible-nav-dropdown3">
                                                <NavDropdown.Item href="/kloyalty">{t('Navigation.My K-Loyalty')}</NavDropdown.Item>
                                                <NavDropdown.Item href="/dealer/about">{t('Navigation.About the Program')}</NavDropdown.Item>
                                            </NavDropdown>
                                        </>
                                    }

                                    <Nav.Link href="/dealer/helpcenter">{helpNav}</Nav.Link>
                                </Nav>
                                {userInfo && userInfo.isAdmin &&
                                    <Nav className="ml-auto">
                                        <NavDropdown title={advancedNav} id="collapsible-nav-dropdown4" className="nav-right-item nav-extended-dropdown" onToggle={(isOpen) => setMenuOpen(isOpen)}>
                                            <NavDropdown.Item as="div">
                                                <Container>
                                                    <Row>
                                                        <Col lg={{ offset: 8, size: 2 }}>
                                                            <h2 className="heading vertical-line">ADVANCED</h2>
                                                        </Col>

                                                        <Col lg={2}>
                                                            <Row className="border-left">
                                                                <Col sm={3}>
                                                                    <h3 className="heading" onClick={() => navigate("/comingsoon")}>Language Admin</h3>
                                                                    <h3 className="heading" onClick={() => navigate("/comingsoon")}>Promo Admin</h3>
                                                                    <h3 className="heading" onClick={() => navigate("/inventorylist")}>Inventory Admin</h3>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </Nav>
                                }

                                {userInfo && userInfo.loginType !== 5 &&
                                    <Nav className="ml-auto">
                                        <NavDropdown title={feedbackNav} id="collapsible-nav-dropdown4" className="nav-right-item nav-contact-dropdown nav-extended-dropdown" show={menuOpen} onToggle={(isOpen) => { setMenuOpen(isOpen); setStarRating(null);} }>
                                            <NavDropdown.Item as="div" onClick={(e) => e.stopPropagation()}>
                                                <Container>
                                                    <form className="shipping-form active-form" onSubmit={handleSubmit(onSubmit)} autoComplete="off">
                                                        <Row>
                                                            <Col sm={12}>
                                                                <h2 className="heading">We'd love your feedback on the new K-Dealer Parts and Accessories Store!</h2>
                                                                <p>What would you like to tell us about your experience today?</p>
                                                            </Col>

                                                            <Col sm={12}>
                                                                <Form.Group className="mb-3" controlId="contactUsMessage" as={Row}>
                                                                    <Form.Label column sm={3}>Message<span className="red">*</span></Form.Label>
                                                                    <Col sm={9}>
                                                                        <Controller
                                                                            name="message"
                                                                            control={control}
                                                                            rules={{
                                                                                required: true,
                                                                            }}
                                                                            render={({ field }) => (
                                                                                <Form.Control style={{ height: '120px' }} as="textarea" type="text" aria-required="true" placeholder="Your Message" maxLength={500} {...field} className={`form-control ${errors.message ? 'is-invalid' : ''}`} />
                                                                            )}
                                                                        />
                                                                    </Col>
                                                                </Form.Group>
                                                            </Col>

                                                            <Col sm={12}>
                                                                <h4 className="heading">Rate your experience<span className="red">*</span></h4>
                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <div className="svg-row star-row">
                                                                            <div className={userRate >= 1 ? 'force-filled' : ''}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" onClick={() => setStarRating(1)}>
                                                                                    <path className="fill" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                    <path className="outline" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                </svg>
                                                                            </div>

                                                                            <div className={userRate >= 2 ? 'force-filled' : ''}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" onClick={() => setStarRating(2)}>
                                                                                    <path className="fill" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                    <path className="outline" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                </svg>
                                                                            </div>

                                                                            <div className={userRate >= 3 ? 'force-filled' : ''}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" onClick={() => setStarRating(3)}>
                                                                                    <path className="fill" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                    <path className="outline" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                </svg>
                                                                            </div>

                                                                            <div className={userRate >= 4 ? 'force-filled' : ''}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" onClick={() => setStarRating(4)}>
                                                                                    <path className="fill" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                    <path className="outline" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                </svg>
                                                                            </div>

                                                                            <div className={userRate >= 5 ? 'force-filled' : ''}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" onClick={() => setStarRating(5)}>
                                                                                    <path className="fill" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                    <path className="outline" d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765
                                                                                    c-.33-.314-.16-.888.282-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0
                                                                                    l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.523 3.356.83 4.73
                                                                                    c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                                {starMsg &&
                                                                    <p className="red">Please provide a star rating with your feedback.</p>    
                                                                }

                                                                <hr />

                                                                <Row>
                                                                    <Col sm={12}>
                                                                        <Form.Check className="radio-consent" defaultChecked
                                                                            label="I consent to K-Dealer collecting and using my feedback to improve their products and services."
                                                                            name="consent" type="checkbox" {...register("consent")}
                                                                        />
                                                                    </Col>

                                                                    <Col sm={12} className="text-center mt-3">
                                                                        <Button variant="primary" onClick={handleSubmit} type="submit">
                                                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                                                            </svg>
                                                                            SUBMIT
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </form>                                                    
                                                </Container>
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                    </Nav>
                                }
                               
                            </Navbar.Collapse>
                        </Container>
                    </Navbar>
                    :
                    <></>
                }
            </header>

            <OrderSessionPopup show={showCartModal} handleShowCartClose={handleShowCartClose}></OrderSessionPopup>

            <ItemInquiry show={showItemModal} handleClose={handleItemModalClose} handleSelectedItems={handleSelectedItems} initialValues={ItemsToitemInquiry} orderType={1} autoSubmit={true} />

            <Modal show={popUpModal} onHide={handleHideModal} dialogClassName="dealer-section" centered>
                <Modal.Header closeButton>
                    <Modal.Title>NOTICE</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                            <p>{popUpMsg}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col sm={12} className="text-left">
                            <Button variant="primary" onClick={handleHideModal}>
                                <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                </svg>
                                CLOSE
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>            

            <Modal className="loader-div" id="loader" show={pop} onHide={handleClosePop} size="lg" centered backdrop="static" keyboard={false}>
                <PulseLoader color="#66cc33" size="20px" margin="12px" />
            </Modal>
        </>
    )
}

export default NavMenu;